// extracted by mini-css-extract-plugin
export default {"paper":"_3wf6pfpf0octlJel3VUitX","label":"_1gYeeHtrC9aUY68LoQ-Fo"};